module.exports = __webpack_public_path__ + "img/RightButtonRollover.a27d8b8f.webp";